/**
 * @generated SignedSource<<060721b686d0320d28ae64678555aa8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportServices_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupSelect_data" | "ServicesSelect_data">;
  readonly " $fragmentType": "PackageEditTransportServices_data";
};
export type PackageEditTransportServices_data$key = {
  readonly " $data"?: PackageEditTransportServices_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportServices_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportServices_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceGroupSelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicesSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c2e6f02724b9d1029ce4d80fe1d29cb5";

export default node;
